import _ from 'lodash';
import appHelpers from 'app/app-helpers';
import actionTypes from '../actions/action-types';

const initialState = {
  current: {},
  draft: false,
  properties: {},
  isLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_LOGIN_POPUP_REQUEST:
    case actionTypes.FETCH_LOGIN_POPUP_FAILURE:
      return {
        ...state,
        isLoading: action.isLoading,
        current: {},
      };
    case actionTypes.FETCH_LOGIN_POPUP_SUCCESS: {
      const popups = action.result.entries.reduce((popupArr, entry) => {
        const newEntry = _.cloneDeep(entry);
        newEntry.fields = appHelpers.getFieldsFromEntry(entry);
        return popupArr.concat(newEntry);
      }, []);
      const draft = action.result.versionType === 'DRAFT';
      return {
        ...state,
        isLoading: action.isLoading,
        current: popups[0] || {},
        draft,
        properties: { ...action.result.properties },
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/reducers/login-popup.reducer.js